module.exports = __webpack_public_path__ + "static/media/07.9a8ab034.jpg";